import {
  DEFAULT_PER_PAGE,
  DEFAULT_PAGE,
} from '@/finsight/application/actions/bonds/constants';

export const initialFiltersState = {
  sortBy: '',
  sortOrder: '',
  page: 1,
  perPage: 25,
  search: '',
};

export const initialTraceData = {
  trades: {
    collection: [],
    totalCount: 0,
  },
  lastImportAt: '',
};

export const defaultFiltersPayload = {
  includedAssetClassId: null,
  dateFrom: null,
  dateTo: null,
  includedTimeFrom: null,
  includedTimeTo: null,
  maturityDateFrom: null,
  maturityDateTo: null,
  includedSizeFrom: null,
  includedSizeTo: null,
  includedPriceFrom: null,
  includedPriceTo: null,
  includedCouponFrom: null,
  includedCouponTo: null,
  includedSectorIds: [],
  includedSubsectorIds: [],
  includedIssuerIds: [],
  includedContraPartyTypes: [],
  includedRemunerations: [],
  includedReportingPartySides: [],
  includedReportingPartyTypes: [],
  includedTradeStatuses: [],
  includedDealIds: [],
  excludedSectorIds: [],
};

export const defaultTileFilterPayload = {
  perPage: DEFAULT_PER_PAGE,
  page: DEFAULT_PAGE,
  search: '',
};
